"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependencyRelationFieldLogic = void 0;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const comparisons_1 = require("../../comparisons");
const types_1 = require("@smartsuite/types");
const field_logic_1 = require("../../field-type-registry/field-logic");
const array_1 = require("../../helpers/array");
const mapping_1 = require("../../helpers/mapping");
const intl_1 = require("../../locale/intl");
const dependency_relation_fieldtype_1 = require("../../safe-field-value/reference-fields/dependency-relation-field/dependency-relation.fieldtype");
const texts_1 = require("../../texts");
const clipboard_1 = require("../../utils/clipboard");
const dom_1 = require("../../utils/dom");
const fields_1 = require("../../utils/fields");
const record_1 = require("../../utils/record");
const helpers_1 = require("./helpers");
const dependency_relation_1 = require("../../clipboard/dependency-relation");
class DependencyRelationFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor(config, appRecordsService) {
        super(config, appRecordsService);
        this.name = "dependencyrelationfield";
        this.label = (0, intl_1.$t)(texts_1.dependencyFieldText.dependency);
        this.icon = "linked-record";
        this.iconColor = "#3A86FF";
        this.placeholder = "";
        this.fieldValueGetter = new dependency_relation_fieldtype_1.DependencyRelationFieldValueGetter();
        this.clipboardPasteRules = {
            dependencyrelationfield: clipboard_1.clipboardToSelf,
            linkedrecordfield: dependency_relation_1.clipboardLRToDependencyRelation,
        };
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is_empty: comparisons_1.isEmptyList,
            is_not_empty: comparisons_1.isNotEmptyList,
            contains: comparisons_1.contains,
            not_contains: comparisons_1.notContains,
            has_all_of: comparisons_1.hasAllOf,
            has_any_of: comparisons_1.hasAnyOf,
            is_exactly: comparisons_1.isExactly,
        };
        this.aggregates = {};
        if (appRecordsService) {
            Object.keys(clipboard_1.textPasteRules).forEach((key) => {
                // @ts-expect-error: Need to resolve
                this.clipboardPasteRules[key] =
                    (0, dependency_relation_1.textToDependencyRelation)(appRecordsService);
            });
        }
    }
    getEmptyValue() {
        return [];
    }
    isValueEqual(fieldValue1, fieldValue2) {
        return (0, react_fast_compare_1.default)(fieldValue1, fieldValue2);
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    isFieldExpandableOnRecordModal() {
        return true;
    }
    valueToString(fieldValue) {
        if (!fieldValue) {
            return "";
        }
        const relationIds = (0, helpers_1.getUniqueRelationRecordsIds)(fieldValue);
        const records = this.appRecordsService.getMultipleRelatedRecords(relationIds);
        return this.recordsToString(records);
    }
    recordsToString(records) {
        return records
            .map((record) => (0, record_1.getTitleOrUntitledRecordString)(record))
            .join(", ");
    }
    getViewControlRules(field) {
        return {
            ...super.getViewControlRules(field),
            nestedFieldsInFieldsToDisplay: "hide",
            fieldInSort: "hide",
            nestedFieldsInSort: "hide",
            nestedFieldsInFilter: "hide",
            fieldInGroup: "hide",
            nestedFieldsInGroup: "hide",
            fieldInSpotlight: "hide",
            nestedFieldsInSpotlight: "hide",
            disableFieldInTextSearch: "hide",
        };
    }
    getInlineEditRules(field) {
        const baseInlineEditRules = super.getInlineEditRules(field);
        return {
            ...baseInlineEditRules,
            editorWidth: "100%",
            switchToInputControl: "OnCellSelect",
            editOnStartTyping: false,
            saveKeys: types_1.navigationKeys,
            enableCopyEventInEditMode: true,
            enablePasteEventInEditMode: true,
            inputControlEditMode: "OnShow",
            cellPresenceEventMode: "OnModalOpen",
            allowAddRecordToGroup: false,
        };
    }
    processFilterValue(filterValue, comparison) {
        if (["is_empty", "is_not_empty"].includes(comparison)) {
            return null;
        }
        return filterValue;
    }
    processFieldValue(record, slug, comparison, field) {
        const fieldValue = (0, fields_1.getValueFromRecordByField)(record, field);
        const relationIDs = (0, helpers_1.getUniqueRelationRecordsIds)(fieldValue);
        const relatedRecords = this.appRecordsService
            .getMultipleRelatedRecords(relationIDs)
            .filter(record_1.isRecordNotDeleted);
        const relatedIDs = relatedRecords.map(({ id }) => id);
        if (["is_empty", "is_not_empty"].includes(comparison)) {
            return relatedIDs;
        }
        if (["contains", "not_contains"].includes(comparison)) {
            return this.recordsToString(relatedRecords);
        }
        if (!relatedIDs) {
            return [];
        }
        return relatedIDs;
    }
    filterValueToString(filterValue, field, userPreferences, comparison) {
        if (["is_empty", "is_not_empty"].includes(comparison)) {
            return "";
        }
        if (["contains", "not_contains"].includes(comparison)) {
            return String(filterValue);
        }
        if (!Array.isArray(filterValue)) {
            return "";
        }
        return this.appRecordsService
            .getMultipleRelatedRecords((0, array_1.shallowUnique)(filterValue))
            .filter(record_1.isRecordNotDeleted)
            .map((item) => (0, record_1.getTitleOrUntitledRecordString)(item))
            .join(", ");
    }
    getFilterComponentData(field, comparison) {
        return {
            ...super.getFilterComponentData(field, comparison),
            placeholder: comparison === "contains" || comparison === "not_contains"
                ? (0, intl_1.$t)(texts_1.linkedRecordFieldText.enter_record)
                : (0, intl_1.$t)(texts_1.linkedRecordFieldText.select_record),
        };
    }
    getGroupValues(fieldValue) {
        if (!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.length)) {
            return [];
        }
        const uniqueIds = (0, helpers_1.getUniqueRelationRecordsIds)(fieldValue);
        const recordsMap = (0, mapping_1.arrayToMap)(this.appRecordsService
            .getMultipleRelatedRecords(uniqueIds)
            .filter(record_1.isRecordNotDeleted), "id");
        return fieldValue
            .filter(({ record }) => recordsMap.has(record))
            .map((relation) => [relation]);
    }
    /**
     * Returns a concatenated string of IDs.
     * Group by ID to avoid having different entries in the same group if the title is equal.
     *
     * @param fieldValue    value from a record
     */
    groupByKey(fieldValue) {
        if (!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.length)) {
            return "";
        }
        const allIds = fieldValue.map(({ record }) => record);
        return allIds.join(", ");
    }
    sortKey(fieldValue) {
        if (!(fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.length)) {
            return "";
        }
        const relationIds = (0, helpers_1.getUniqueRelationRecordsIds)(fieldValue).join(", ");
        return `${this.valueToString(fieldValue)}, ${relationIds}`;
    }
    canChangeValue() {
        return false;
    }
    isSupportedByBulkAction() {
        return false;
    }
    getContentSize(fieldValue, field, userPreferences, record, font) {
        const { dependency_mode } = field.params;
        const isAdvanced = dependency_mode === "advanced";
        const textElementsGap = 8;
        const pillIcon = 22;
        const pillDelimiterWidth = 7;
        let pillText = "";
        for (const relation of fieldValue) {
            const record = this.appRecordsService.getRelatedRecord(relation.record);
            const title = (0, record_1.getTitleOrUntitledRecordString)(record);
            pillText += isAdvanced
                ? `${title} ${relation.type} ${relation.lag}`
                : title;
        }
        let size = (0, dom_1.getTextSize)(pillText, undefined, font);
        if (isAdvanced) {
            size += pillIcon * fieldValue.length;
            size += textElementsGap * 3 * fieldValue.length;
        }
        if (fieldValue.length > 1) {
            size += pillDelimiterWidth * fieldValue.length - 1;
        }
        return size;
    }
    getNestedFormulaFieldsSchema(fieldSchema) {
        var _a, _b, _c;
        if (fieldSchema.linked_application) {
            const schema = (_b = (_a = this.appRecordsService).getFormulaApplicationSchema) === null || _b === void 0 ? void 0 : _b.call(_a, fieldSchema.linked_application);
            return (_c = schema === null || schema === void 0 ? void 0 : schema.fields) !== null && _c !== void 0 ? _c : [];
        }
        return [];
    }
}
exports.DependencyRelationFieldLogic = DependencyRelationFieldLogic;
